import Cookies from "js-cookie";
export interface PersistStoreageType<S> {
  getItem: (name: string) => string | null;
  setItem: (name: string, value: string) => unknown | Promise<unknown>;
  removeItem: (name: string) => unknown | Promise<unknown>;
}

// Corrected StateStorage implementation
export const cookiePersistStorage: PersistStoreageType<any> = {
  setItem: (name, value) => {
    Cookies.set(name, value, {
      expires: 30 * 24 * 60 * 60,
    });
  },
  getItem: (name): string | null => {
    return Cookies.get(name) ?? null;
  },
  removeItem: (name) => {
    Cookies.remove(name);
  },
};
